import { Component, OnInit } from '@angular/core';
import { LoggerService } from '../../../../../shared/services/logger.service';
import { ClaimsDataService } from '../../../services/claims-data.service';
import { CommercialLoggingService } from '../../../services/commercial-logging.service';
import { GetClaimsService } from '../../../services/get-claims.service';

import { BreadCrumb } from '@nationwide/internet-servicing-angular-components';
import { PolicyInfoService } from 'app/commercial/claims/services/policy-info.service';
import { environment } from 'environments/environment';
import { take } from 'rxjs/operators';
import { commercialConstants } from '../../../../../common/commercial-constants';

@Component({
    selector: 'is-claim-contacts',
    templateUrl: './claim-contacts.component.html',
    styleUrls: ['./claim-contacts.component.scss'],
    standalone: false
})
export class ClaimContactsComponent implements OnInit {
    breadCrumbs: BreadCrumb[];
    claimInfo: any;
    claimOwner = [];
    claimOwnerEmail = false;
    currentPage = 'Contacts';
    homeIconLink = environment.NATIONWIDE.accountSummaryPage;
    injury = [];
    injuryEmail = false;
    propertyDamage = [];
    propertyDamageEmail = false;
    serviceFlag = false;
    vehicleDamage = [];
    vehicleDamageEmail = false;

    constructor(
        private getClaimsService: GetClaimsService,
        private LOGGER: LoggerService,
        public claimsDataService: ClaimsDataService,
        public policyInfoService: PolicyInfoService,
        private commercialLoggingService: CommercialLoggingService
    ) { }
    claimOwnerInfo(): boolean {
        const size = this.claimOwner.length;
        if (size === 1) {
            this.claimOwnerEmail = !!Object.getOwnPropertyDescriptor(this.claimOwner[0].adjuster, 'email');
            return true;
        } else {
            return false;
        }
    }
    getClaimInfo(): void {
        this.claimInfo = this.claimsDataService.getClaimInformation();
        if (this.claimInfo) {
            this.serviceFlag = true;
        }
    }

    getContacts(): void {
        const claim = this.claimsDataService.getClaimNumber();
        this.getClaimsService.getClaimContacts(claim).pipe(take(1)).subscribe((response) => {
            for (const iterator of response.adjusterSummaries) {
                if (iterator.role === 'claimOwner') {
                    this.claimOwner.push(iterator);
                } else if (iterator.exposureType === 'vehicleDamage') {
                    this.vehicleDamage.push(iterator);
                } else if (iterator.exposureType === 'propertyDamage') {
                    this.propertyDamage.push(iterator);
                } else if (iterator.exposureType === 'injury') {
                    this.injury.push(iterator);
                }
            }
            this.commercialLoggingService.logServiceSuccess(
                this.LOGGER,
                this.currentPage,
                'GetClaimsService',
                'getClaimContacts',
                this.getLogMetadata({ claimsDisplayCount: '1' })
            );
        }, (error) => {
            this.commercialLoggingService.logServiceFailure(
                this.LOGGER,
                this.currentPage,
                'GetClaimsService',
                'getClaimContacts',
                this.getLogMetadata(),
                error
            );
        });
    }
    injuryInfo(): boolean {
        const size = this.injury.length;
        if (size === 1) {
            if (this.claimOwner[0].adjuster.displayName === this.injury[0].adjuster.displayName) {
                return false;
            } else {
                this.injuryEmail = !!Object.getOwnPropertyDescriptor(this.injury[0].adjuster, 'email');
                return true;
            }
        } else {
            return false;
        }
    }

    ngOnInit(): void {
        this.breadCrumbs = [
            {
                name: 'Package (PAK) Claims',
                link: `${commercialConstants.URLS.pakClaimsList}`
            }, {
                name: 'Claim Overview',
                link: `${commercialConstants.URLS.claimOverview}`
            }
        ];
        this.getClaimInfo();
        this.commercialLoggingService.logPageLoad(this.LOGGER, this.currentPage, this.getLogMetadata());
        this.getContacts();
    }
    propertyDamageInfo(): boolean {
        const size = this.propertyDamage.length;
        if (size === 1) {
            if (this.claimOwner[0].adjuster.displayName === this.propertyDamage[0].adjuster.displayName) {
                return false;
            } else {
                this.propertyDamageEmail = !!Object.getOwnPropertyDescriptor(this.propertyDamage[0].adjuster, 'email');
                return true;
            }
        } else {
            return false;
        }
    }

    vehicleDamageInfo(): boolean {
        const size = this.vehicleDamage.length;
        if (size === 1) {
            if (this.claimOwner[0].adjuster.displayName === this.vehicleDamage[0].adjuster.displayName) {
                return false;
            } else {
                this.vehicleDamageEmail = !!Object.getOwnPropertyDescriptor(this.vehicleDamage[0].adjuster, 'email');
                return true;
            }
        } else {
            return false;
        }
    }

    private getLogMetadata(additionalFields: any = {}): any {
        return {
            policyNumber: this.claimsDataService.getClaimsPolicyNumber(),
            policyType: this.claimsDataService.getClaimsPolicyType(),
            lineOfBusiness: this.claimsDataService.getFnolFlow(),
            claimsDisplayCount: this.claimInfo ? '1' : this.claimsDataService.getClaimsDisplayCount() || 'UNKNOWN',
            alphaState: this.claimsDataService.getPrimary(this.claimsDataService.getClaimsPackage()?.address)?.state || 'UNKNOWN',
            previousUrl: window.sessionStorage.getItem('previousUrl') || '',
            claimNumber: this.claimsDataService.getClaimNumber() || '',
            claimStatus: this.claimInfo?.claimState || '',
            incidentDate: this.claimInfo?.lossDate || '',
            lossCause: this.claimInfo?.lossCause || '',
            ...additionalFields
        };
    }
}
